import React from "react";
import IllustRover from "./GraphicIllust_Rover.svg";

interface Props {
  customMessage?: string;
}

const NoResultsFound: React.FC<Props> = (props: Props): JSX.Element => {
  const { customMessage } = props;

  let messageResult = null;

  if (customMessage) {
    messageResult = customMessage;
  } else {
    messageResult = "No results found.";
  }

  return (
    <div className="no-results-found-wrapper" role="heading" aria-level={1}>
      <div className="no-results-found-container">
        <span>{messageResult}</span>
        <img src={IllustRover} alt="" />
      </div>
    </div>
  );
};

export default NoResultsFound;
